import React, { Component, useState } from "react";
import { ToastContainer } from "react-toastify";
import $ from "jquery";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigFinance";
import Constant from "../../constants";
import { Form, Button, Dropdown, Grid, Header } from "semantic-ui-react";
import { Pagination, Spinner } from "react-bootstrap";
import ReactExport from "react-data-export";
import { Link } from "react-router-dom";
import { parse } from "date-fns";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const moment = require("moment");

export default class Vieworders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retailersListData: "",
      selectedStatus: "",
      selectedRetailerId: "",
      selectedStartDate: "",
      selectedEndDate: "",
      searchString: "",
      orderDetailsView: "collapse-hide",
      orderListView: "container",
      pageNumber: 1,
      totalPages: 1,
      totalCount: 0,
      pageSize: 100,
      isLoading: true,
      ordersView: [],
      currentOrders: [],
      remove_icon_search: "remove_icon collapse-hide clear_icon",
      reference_id: "",
      settlementStatus: "",
    };
    this.ordersTableRef = React.createRef();
    this.getAllOrders = this.getAllOrders.bind(this);
  }

  // To get detais after first render
  componentDidMount = () => {
    this.orderStatusCount();
    this.fetchRetailerInfo();
    this.getAllOrders();
    this.getRejectionResonslist();
  };

  //  For getting orderStatusCount
  orderStatusCount = () => {
    let retailerId = this.state.selectedRetailerId;
    let startDate = this.state.selectedStartDate;
    let endDate = this.state.selectedEndDate;
    let orderStatus = this.state.selectedStatus;
    let searched = this.state.searchString;

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/orderProcess/getAdminOrderDashboardCount",
      {
        retailer_id: retailerId,
        start_date: startDate,
        end_date: endDate,
        order_status: orderStatus,
        order_search_id: searched,
      }
    )
      .then((response) => {
        this.state.all = response.data.data[0].all;
        this.state.pending = response.data.data[0].pending;
        this.state.reviewed = response.data.data[0].reviewed;
        this.state.processing = response.data.data[0].processing;
        this.state.shipping = response.data.data[0].shipping;
        this.state.delivered = response.data.data[0].delivered;
        this.state.cancelled = response.data.data[0].cancelled;

        this.forceUpdate();
      })
      .catch((error) => {
        // Surfaced deliberately: an empty catch here once hid a 500 from this
        // endpoint and made it look like the list simply had no orders.
        console.error("orderStatusCount failed:", (error && error.response && error.response.data) || error);
      });
  };

  // Get the retailers list
  fetchRetailerInfo() {
    Httpconfig.httptokenget(Constant.siteurl + "api/retailer/")
      .then((response) => {
        let listData = response.data.data;
        let retailersListData = listData.map((item, index) => ({
          key: item.id,
          text: item.storename,
          value: item.id,
        }));
        this.state.retailersListData = retailersListData;

        this.forceUpdate();
      })
      .catch((error) => {
        // Surfaced deliberately: an empty catch here once hid a 500 from this
        // endpoint and made it look like the list simply had no orders.
        console.error("fetchRetailerInfo failed:", (error && error.response && error.response.data) || error);
      });
  }
  // On retalier selection
  onRetailerListChange = (event, data) => {
    let selectedretailerValue = data.value;

    if (selectedretailerValue != "") {
      const keys = data.options.find(
        (data) => data.value === selectedretailerValue
      );
      const selectedretailer = {
        id: keys.key,
        medicineid: keys.text,
        medicinename: keys.value,
      };
      this.state.selectedRetailerName = keys.text;
      this.state.selectedRetailerId = selectedretailerValue;
      this.forceUpdate();
      this.getAllOrders();
      this.orderStatusCount();
    }
  };

  // get all the orders
  getAllOrders(page) {
    let retailerId = this.state.selectedRetailerId;
    let startDate = this.state.selectedStartDate;
    let endDate = this.state.selectedEndDate;
    let orderStatus = this.state.selectedStatus;
    let searched = this.state.searchString;
    let pageNumber = typeof page === "number" ? page : 1;
    let PaidAmount = "";
    let finalordersarray = [];

    if (searched == "") {
      searched = $("#input-search1").val();
      this.state.searchString = searched;
    }

    this.state.isLoading = true;
    this.forceUpdate();

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/orderProcess/getAdminOrderDashboardDetails",
      {
        retailer_id: retailerId,
        start_date: startDate,
        end_date: endDate,
        order_status: orderStatus,
        order_search_id: searched,
        page_number: pageNumber,
        page_size: this.state.pageSize,
      }
    )
      .then((response) => {
        // store current orders (page 1 or refreshed list)
        this.state.currentOrders = response.data.data;
        this.state.pageNumber = response.data.page || pageNumber;
        this.state.totalPages = response.data.totalPages || 1;
        this.state.totalCount =
          response.data.totalCount != null
            ? response.data.totalCount
            : response.data.data.length;

        // build table rows from the persistent currentOrders array so S.No remains sequential
        // but only increment S.No for rows that are actually rendered (i.e. have patient_tbl).
        // The offset carries the count from earlier pages so numbering continues across them.
        const serialOffset = (this.state.pageNumber - 1) * this.state.pageSize;
        let visibleIndex = 0;
        const ordersView = this.state.currentOrders.map((LoadedData, idx) => {
          // if there's no patient data we skip rendering a visible row but still keep it in currentOrders
          const hasPatient =
            LoadedData?.patient_tbl && LoadedData?.patient_tbl?.name;
          if (!hasPatient) return null;
          visibleIndex = visibleIndex + 1;
          const serial = serialOffset + visibleIndex;
          if (LoadedData?.patient_tbl && LoadedData?.patient_tbl?.name) {
            const isDelivered =
              LoadedData?.order_status_tbl?.status === "Delivered";
            let PaidAmount =
              LoadedData?.total_paid != null
                ? parseInt(LoadedData?.total_paid)
                : 0;
            if (LoadedData?.total_paid) {
              PaidAmount = PaidAmount.toFixed(2).replace(
                /\d(?=(\d{3})+\.)/g,
                "$&,"
              );
            }

            const deliveryCharges =
              LoadedData?.delivery_charges != undefined
                ? parseFloat(LoadedData?.delivery_charges).toFixed(2)
                : 0;

            const commissionCost =
              LoadedData.total_paid &&
              LoadedData.retailer_registration_tbl &&
              LoadedData.retailer_registration_tbl.commission &&
              LoadedData.retailer_registration_tbl.commission != undefined
                ? (parseInt(LoadedData.retailer_registration_tbl?.commission) /
                    100) *
                  parseInt(LoadedData.total_paid)
                : 0;

            const toBePaid =
              PaidAmount != 0
                ? parseFloat(LoadedData?.total_paid || 0) -
                  (Number(commissionCost) + Number(deliveryCharges))
                : 0;

            let hoursDiff = moment(
              LoadedData.order_date,
              "YYYY-MM-DD hh:mm:ss"
            ).fromNow();

            finalordersarray.push({
              Sno: serial,
              "Customer Name":
                LoadedData?.delivery_address_tbl && LoadedData?.delivery_address_tbl.name
                  ? LoadedData?.delivery_address_tbl?.name.charAt(0).toUpperCase() +
                    LoadedData?.delivery_address_tbl?.name.slice(1) +
                    "," +
                    LoadedData?.delivery_address_tbl?.mobile_no
                  : "--",
              Retailer:
                LoadedData?.retailer_registration_tbl != null
                  ? LoadedData?.retailer_registration_tbl?.storename +
                    "," +
                    LoadedData?.retailer_registration_tbl?.address +
                    "," +
                    LoadedData?.retailer_registration_tbl?.email +
                    "," +
                    LoadedData?.retailer_registration_tbl?.mobile_number
                  : "--",
              "Order Id": LoadedData?.id,
              "Order Date":
                LoadedData?.order_date != null
                  ? moment(LoadedData?.order_date).format("DD-MM-YYYY")
                  : "--",
              Amount: PaidAmount,
              Items: Object.keys(LoadedData?.order_processing_tbls)?.length,
              "Order Status": LoadedData?.order_status_tbl?.status,
            });
            return (
              <tr>
                <td>{serial}</td>
                <td>
                  {LoadedData?.delivery_address_tbl && LoadedData?.delivery_address_tbl.name
                    ? LoadedData?.delivery_address_tbl?.name.charAt(0).toUpperCase() +
                      LoadedData?.delivery_address_tbl?.name.slice(1)
                    : // "," +
                      // LoadedData.patient_tbl.phone_number
                      "--"}{" "}
                  <h6 class="td_down">
                    {LoadedData?.delivery_address_tbl &&
                    LoadedData?.delivery_address_tbl?.mobile_no
                      ? LoadedData?.delivery_address_tbl?.mobile_no
                      : "--"}
                  </h6>
                </td>
                <td>
                  {LoadedData?.retailer_registration_tbl != null ? (
                    <div class="dropdown">
                      <p class="dropbtn">
                        {LoadedData?.retailer_registration_tbl?.storename
                          ? LoadedData?.retailer_registration_tbl?.storename
                          : "--"}{" "}
                      </p>

                      <div class="dropdown-content">
                        <h3>
                          {LoadedData?.retailer_registration_tbl?.storename
                            ? LoadedData?.retailer_registration_tbl?.storename
                            : "--"}
                        </h3>
                        <p>
                          {}
                          {LoadedData?.retailer_registration_tbl?.address
                            ? LoadedData?.retailer_registration_tbl?.address
                            : ""}
                        </p>
                        <p>
                          {" "}
                          {LoadedData?.retailer_registration_tbl?.email
                            ? LoadedData?.retailer_registration_tbl?.email
                            : ""}
                        </p>
                        <p>
                          {" "}
                          {LoadedData?.retailer_registration_tbl?.mobile_number
                            ? LoadedData?.retailer_registration_tbl
                                ?.mobile_number
                            : ""}
                        </p>
                      </div>
                    </div>
                  ) : (
                    "--"
                  )}
                </td>
                <td style={{ width: "180px" }}>
                  {/* <p onClick={this.orderDetailsView.bind(this, LoadedData.id)}> */}
                  <p>{LoadedData?.id}</p>
                </td>
                <td style={{ width: "180px" }}>
                  {LoadedData?.order_date != null
                    ? moment(LoadedData?.order_date).format("DD-MM-YYYY")
                    : "--"}
                </td>

                {/* <td class="presc_field">
                {LoadedData.cart_prescriptions_tbl != null
                  ? LoadedData.cart_prescriptions_tbl.medical_document.map(
                      (presImages, num) => {
                        return (
                          <a
                            href={
                              presImages ? Constant.imgurl + presImages : ""
                            }
                            target="_blank"
                          >
                            <img
                              class="presc_img"
                              src="../images/retailer/presc.svg"
                            />
                          </a>
                        );
                      }
                    )
                  : "--"}
              </td> */}

                {/* <td style={{ width: "180px" }}>{Object.keys(LoadedData.order_processing_tbls).length}</td> */}

                <td style={{ width: "180px" }}>
                  {LoadedData?.invoice != null ? (
                    <>
                      <a
                        href={
                          LoadedData?.invoice.startsWith("/uploads")
                            ? Constant?.imgurl + LoadedData?.invoice
                            : LoadedData?.invoice
                        }
                        target="_blank"
                      >
                        View Invoice
                      </a>
                    </>
                  ) : (
                    <>--</>
                  )}
                </td>

                <td style={{ width: "180px" }}>
                  {LoadedData?.retailer_registration_tbl &&
                  LoadedData?.retailer_registration_tbl?.commission &&
                  LoadedData?.retailer_registration_tbl?.commission !=
                    undefined ? (
                    <>
                      <h6>
                        {LoadedData?.retailer_registration_tbl?.commission} %
                      </h6>

                      {commissionCost != 0 ? (
                        <h6>₹{commissionCost.toFixed(2)}</h6>
                      ) : (
                        <>--</>
                      )}
                    </>
                  ) : (
                    <>--</>
                  )}
                </td>

                <td style={{ width: "180px" }}>
                  {LoadedData?.retailer_registration_tbl &&
                  LoadedData?.delivery_charges != undefined ? (
                    <>
                      <h6>₹{LoadedData?.delivery_charges}</h6>
                    </>
                  ) : (
                    <>--</>
                  )}
                </td>

                <td style={{ width: "180px" }}>
                  <h6>₹{toBePaid.toFixed(2)}</h6>
                </td>

                <td style={{ width: "180px" }}>
                  {LoadedData?.retailer_registration_tbl != null
                    ? LoadedData?.retailer_registration_tbl?.currency
                    : ""}
                  {LoadedData?.payable_amount ? PaidAmount : "--"}
                </td>

                <td style={{ width: "180px" }}>
                  {LoadedData.order_status < 5 ? (
                    <div class="dropdown">
                      <p class="dropbtn">
                        {LoadedData?.order_status_tbl?.status}{" "}
                        <h6 class="td_down">{hoursDiff}</h6>
                      </p>
                    </div>
                  ) : (
                    <p class="">
                      {LoadedData?.order_status_tbl?.status ==
                        "Cancelled Refund  Initiated / Refunded" &&
                      LoadedData?.refund_status == 6 ? (
                        <p class="verify_btn">
                          Cancelled <br />
                          Refund Queued For Processing
                        </p>
                      ) : LoadedData?.order_status_tbl?.status == "Cancelled" &&
                        LoadedData?.refund_status == 7 ? (
                        <p class="verify_btn">
                          Cancelled <br />
                          Amound Refunded
                        </p>
                      ) : (
                        LoadedData?.order_status_tbl?.status
                      )}{" "}
                      <h6 class="td_down"></h6>
                    </p>
                  )}
                </td>

                {/* <td style={{ width: "180px" }} >
                {LoadedData.order_status != 6 ? (
                  <React.Fragment>
                    <p
                      data-toggle="modal"
                      data-target="#reject_reason"
                      onClick={this.handleSelectedOrderId.bind(
                        this,
                        LoadedData.id
                      )}
                    >
                      Cancel
                    </p>
                  </React.Fragment>
                ) : (
                  "--"
                )}
              </td> */}

                {/* <td style={{ width: "180px" }}>
                <select
                  class="form-control"
                  id="order_status"
                  name="order_status"
                  value={this.state.settlementStatus}
                  onChange={(e) => {
                    console.log("e.target.value", e.target.value);
                    this.setState({ settlementStatus: e.target.value }, () =>
                      console.log(
                        "settlementStatus: ",
                        this.state.settlementStatus
                      )
                    );
                  }}
                >
                  <option value="">Select</option>
                  <option value="settled">Settled</option>
                  <option value="not_settled">Not Settled</option>
                </select>
              </td> */}

                {/* <td style={{ width: "200px" }}>
                <input
                  type="text"
                  class="form-control"
                  id="reference_id"
                  name="reference_id"
                  onChange={(e) =>
                    this.setState({ reference_id: e.target.value })
                  }
                />
              </td> */}
                {/* <td>
                <button
                  type="submit"
                  class="btn btn-primary"
                  disabled={
                    !this.state.reference_id ||
                    this.state.reference_id.trim() === ""
                  }
                >
                  Save
                </button>
              </td> */}
              </tr>
            );
          }
        });
        this.state.ordersView = ordersView;
        this.state.finalordersarray = finalordersarray;
        this.state.isLoading = false;
        this.forceUpdate();
      })
      .catch((error) => {
        this.state.isLoading = false;
        this.forceUpdate();
        console.log(error);
      });
  }

  // Handle Selected status
  handleSelectedStatus = (status) => {
    this.state.selectedStatus = status;
    $(".stat").removeClass("active");
    $(".status-" + status).addClass("active");
    this.forceUpdate();
    this.getAllOrders();
    this.orderStatusCount();
  };
  // Handle searched string
  handleSearchedString = (event) => {
    let searched = event.target.value;
    if (searched.length > 0) {
      this.state.remove_icon_search = "remove_icon collapse-show";
    } else {
      this.state.remove_icon_search = "remove_icon collapse-hide clear_icon";
    }
    this.setState({ searchString: searched });
    this.state.searchString = searched;
    this.forceUpdate();
    // Do NOT call orderStatusCount or getAllOrders here
  };

  /* change order status */

  ChangeOrderStatus = (orderId, status) => {
    Httpconfig.httptokenput(
      Constant.siteurl + "api/OM/orderProcess/retailerOrderStatus/" + orderId,
      { order_status: status }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          toast.success(response.data.message);
          this.getAllOrders();
          this.orderStatusCount();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  // Reject Order list

  getRejectionResonslist = () => {
    Httpconfig.httptokenget(Constant.siteurl + "api/OM/cancellationReason/")
      .then((response) => {
        if ((response.data.status = 200)) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerRejectList = response.data.data.map(
              (finalLoadedData, num) => {
                return (
                  <p>
                    <input
                      type="checkbox"
                      class="rej_check"
                      name="cancelReasons"
                      id={finalLoadedData.id}
                      onChange={this.cancelReason}
                    />{" "}
                    {finalLoadedData.reason}
                  </p>
                );
              }
            );
            this.state.retailerRejectList = retailerRejectList;
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // update the cancellation reaon

  cancelReason = (event) => {
    let id = event.currentTarget.id;
    if (document.getElementById(id).checked == true) {
      this.state.cancelleReason = id;
    } else {
      this.state.cancelleReason = "";
    }
    this.forceUpdate();
  };

  // Reject order
  rejectOrder = () => {
    let cancelReasonsCheckedCount = $('input[name="cancelReasons"]:checked')
      .length;
    let otherReason = $("#otherReason").val();
    let orderId = this.state.selectedCancelOrderId;
    if (cancelReasonsCheckedCount == 0 && otherReason == "") {
      toast.error("Select Reason for Cancellation");
      return;
    } else {
      let cancelledReason = this.state.cancelleReason;
      Httpconfig.httptokenpost(
        Constant.siteurl + "api/OM/cancellationReason/orderDetails/" + orderId,
        { order_status: "6", cancelled_reason: cancelledReason }
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            toast.success(response.data.message);
            $("#reject_reason").hide();
            $('input[name="cancelReasons"]:checked').prop("checked", "");
            $("#otherReason").val("");
            this.state.cancelleReason = "";
            this.state.selectedCancelOrderId = "";
            this.forceUpdate();
            this.getAllOrders();
            this.orderStatusCount();
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
  // Order details view

  orderDetailsView = (orderId) => {
    this.state.orderDetailsView = "collapse-show";
    this.state.orderListView = "container collapse-hide";
    this.forceUpdate();
    Httpconfig.httptokenget(
      Constant.siteurl + "api/OM/orderProcess/getAdminOrderDetail/" + orderId
    )
      .then((response) => {
        // console.log("---------468-----", response)
        if ((response.data.status = 200)) {
          let assignvalues = [];

          this.items = response.data.data.map((item, key) =>
            assignvalues.push({})
          );

          let invoiceState = Object.assign({}, this.state);
          invoiceState.datatable.rows = assignvalues;
          this.setState(invoiceState);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //  For list view
  showListView = () => {
    this.state.orderDetailsView = "collapse-hide";
    this.state.orderListView = "container collapse-show";
    this.forceUpdate();
  };
  //  for start date
  startDate = (event) => {
    let startDate = event.target.value;

    this.state.selectedStartDate = moment(startDate).format("YYYY-MM-DD");
    this.forceUpdate();
    if (this.state.selectedStartDate && this.state.selectedEndDate) {
      if (this.state.selectedStartDate <= this.state.selectedEndDate) {
        if (
          this.state.selectedEndDate != "" &&
          this.state.selectedStartDate != ""
        ) {
          this.getAllOrders();
          this.orderStatusCount();
        }
      } else {
        toast.error("from date cannot be greater than to date");
      }
    }
  };

  // Start date selection
  endDate = (event) => {
    let endDate = event.target.value;
    this.state.selectedEndDate = moment(endDate).format("YYYY-MM-DD");
    if (this.state.selectedStartDate <= this.state.selectedEndDate) {
      this.forceUpdate();
      if (
        this.state.selectedStartDate != "" &&
        this.state.selectedEndDate != ""
      ) {
        this.getAllOrders();
        this.orderStatusCount();
      }
    } else {
      toast.error("from date cannot be greater than to date");
    }
  };
  //  page change
  handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > this.state.totalPages) {
      return;
    }
    this.getAllOrders(pageNumber);
    // The pager sits below 50 rows, so staying put would leave the reader at the
    // end of the new page. Back to the table head, not the top of the document,
    // so the filters above stay where they were.
    if (this.ordersTableRef.current) {
      this.ordersTableRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  //  rows per page change
  handlePageSizeChange = (event) => {
    const pageSize = parseInt(event.target.value, 10);
    if (!pageSize || pageSize === this.state.pageSize) {
      return;
    }
    this.state.pageSize = pageSize;
    // Back to the first page: the current page number counts in the old size, so
    // keeping it would land the reader somewhere unrelated in the list.
    this.getAllOrders(1);
  };

  //  For selected order id
  handleSelectedOrderId = (orderId) => {
    this.state.selectedCancelOrderId = orderId;
    this.forceUpdate();
  };
  //  For clear search
  handleClearSearch = () => {
    $("#input-search1").val("");
    this.state.searchString = "";
    this.state.remove_icon_search = "remove_icon collapse-hide";

    this.forceUpdate();
    this.getAllOrders();
    this.orderStatusCount();
  };

  //  For clear
  handleClear = (id) => {
    if (id == "start_date") {
      this.state.selectedStartDate = "";
      $("#" + id).val("");
    }
    if (id == "end_date") {
      this.state.selectedEndDate = "";
      $("#" + id).val("");
    }
    if (id == "input-search") {
      this.state.searchString = "";
      $("#" + id).val("");
    }
    this.forceUpdate();
    this.getAllOrders();
    this.orderStatusCount();
  };

  render() {
    return (
      <section id="main_dashboard">
        <div class={this.state.orderListView}>
          <div class="row">
            <div class="col-md-12 no_padding">
              {/* <div class="row">
                <div class="col-md-12 no_padding">
                  <div class="sorting_content">
                    <ol class="breadcrumb">
                      <li class="active">
                        <a href="/finance/dashboard"> Dashboard</a> &gt; Order Medicine &gt;
                        Orders
                      </li>
                    </ol>
                  </div>
                </div>
              </div> */}
              <div id="order_section">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-6 date_sec">
                      <h2>Select Date</h2>
                      <form>
                        <div class="form-group">
                          <input
                            type="date"
                            id="start_date"
                            class="form-control"
                            // Chrome renders the dd-mm-yyyy hint itself and ignores
                            // placeholder on a date input; this uppercases that hint.
                            // Uppercase is wider, so the field also needs a floor -
                            // at the inherited width the calendar icon sat on the
                            // last Y of DD-MM-YYYY.
                            style={{ textTransform: "uppercase", minWidth: "145px" }}
                            placeholder="yyyy-mm-dd"
                            onChange={this.startDate}
                            max={moment().format("YYYY-MM-DD")}
                          />
                          {/* <img
                            class="remove_icon"
                            src="https://www.flaticon.com/svg/static/icons/svg/59/59836.svg"
                            onClick={this.handleClear.bind(this, "start_date")}
                          /> */}
                        </div>
                        <p class="to_txt">To</p>
                        <div class="form-group">
                          <input
                            type="date"
                            id="end_date"
                            class="form-control"
                            // Chrome renders the dd-mm-yyyy hint itself and ignores
                            // placeholder on a date input; this uppercases that hint.
                            // Uppercase is wider, so the field also needs a floor -
                            // at the inherited width the calendar icon sat on the
                            // last Y of DD-MM-YYYY.
                            style={{ textTransform: "uppercase", minWidth: "145px" }}
                            onChange={this.endDate}
                            max={moment().format("YYYY-MM-DD")}
                          />
                          {/* <img
                            class="remove_icon"
                            src="https://www.flaticon.com/svg/static/icons/svg/59/59836.svg"
                            onClick={this.handleClear.bind(this, "end_date")}
                          /> */}
                        </div>
                      </form>
                      <div>
                        <a href="" onClick={() => window.location.reload()}>
                          Clear
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-4 select_ret_sec">
                      <div class="form-group">
                        <label>Select Pharmacy</label>
                        {this.state.retailersListData ? (
                          <Dropdown
                            class="form-control"
                            id="medicines"
                            placeholder={"Select Pharmacy"}
                            fluid
                            clearable
                            search
                            selection
                            options={this.state.retailersListData}
                            onChange={this.onRetailerListChange}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div class="col-lg-2 generate_sec">
                      <ExcelFile
                        element={
                          <a href="#">
                            {" "}
                            <h2>Download XLS</h2>
                          </a>
                        }
                      >
                        <ExcelSheet
                          data={this.state.finalordersarray}
                          name="Order Request"
                        >
                          <ExcelColumn label="Sno" value="Sno" />
                          <ExcelColumn
                            label="Customer Name"
                            value="Customer Name"
                          />
                          <ExcelColumn label="Pharmacy" value="Retailer" />
                          <ExcelColumn label="Order Id" value="Order Id" />
                          <ExcelColumn label="Order Date" value="Order Date" />
                          <ExcelColumn label="Amount" value="Amount" />
                          <ExcelColumn label="Items" value="Items" />
                          <ExcelColumn
                            label="Order Status"
                            value="Order Status"
                          />
                        </ExcelSheet>
                      </ExcelFile>
                    </div>
                  </div>
                </div>
              </div>

              <div id="sorting_sec">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 no_padding">
                      <div class="sorting_content">
                        <div class="sorting_head">
                          <h2>Sorting: </h2>
                        </div>
                        <ul>
                          <li
                            class="stat status-0 active"
                            onClick={this.handleSelectedStatus.bind(this, "")}
                          >
                            All ({this.state.all ? this.state.all : "0"})
                          </li>
                          <li
                            class="stat status-1"
                            onClick={this.handleSelectedStatus.bind(this, "1")}
                          >
                            Pending (
                            {this.state.pending ? this.state.pending : "0"})
                          </li>
                          <li
                            class="stat status-2"
                            onClick={this.handleSelectedStatus.bind(this, "2")}
                          >
                            Prescription review (
                            {this.state.reviewed ? this.state.reviewed : "0"})
                          </li>
                          <li
                            class="stat status-3"
                            onClick={this.handleSelectedStatus.bind(this, "3")}
                          >
                            Processing (
                            {this.state.processing
                              ? this.state.processing
                              : "0"}
                            )
                          </li>
                          <li
                            class="stat status-4"
                            onClick={this.handleSelectedStatus.bind(this, "4")}
                          >
                            Shipped (
                            {this.state.shipping ? this.state.shipping : "0"})
                          </li>
                          <li
                            class="stat status-5"
                            onClick={this.handleSelectedStatus.bind(this, "5")}
                          >
                            Delivered (
                            {this.state.delivered ? this.state.delivered : "0"})
                          </li>
                          <li
                            class="stat status-6"
                            onClick={this.handleSelectedStatus.bind(this, "6")}
                          >
                            Cancelled (
                            {this.state.cancelled ? this.state.cancelled : "0"})
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="search_order">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 no_padding">
                      <form>
                        <div class="form-group">
                          <label>Search order</label>
                          <div class="input-group">
                            <input
                              type="text"
                              id="input-search1"
                              class="form-control"
                              placeholder="Search with Customer Name, Phone Number, Order Id"
                              onKeyUp={this.handleSearchedString}
                            />
                            {/* <img
                              class={this.state.remove_icon_search}
                              src="./images/patient/img/cross-bar.png"
                              onClick={this.handleClearSearch}
                            /> */}
                            <div class="input-group-btn">
                              <div class="btn-group" role="group">
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  onClick={() => {
                                    // Only call orderStatusCount and getAllOrders when search button is clicked
                                    this.getAllOrders();
                                    if (
                                      this.state.searchString &&
                                      this.state.searchString.trim() !== ""
                                    ) {
                                      this.orderStatusCount();
                                    }
                                  }}
                                >
                                  search
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div id="CMS_tab">
                <div class="CMS_content">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12 no_padding">
                        <div id="reg_form">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "10px",
                            }}
                          >
                            <label
                              htmlFor="orders_page_size"
                              style={{ margin: 0, whiteSpace: "nowrap" }}
                            >
                              Rows per page
                            </label>
                            <select
                              id="orders_page_size"
                              class="form-control"
                              style={{ width: "auto" }}
                              value={this.state.pageSize}
                              onChange={this.handlePageSizeChange}
                            >
                              {[10, 20, 50, 100].map((size) => (
                                <option key={size} value={size}>
                                  {size}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div
                            class="table-responsive dataTables_wrapper load_sec"
                            ref={this.ordersTableRef}
                            // The admin navbar is fixed, so without this the first
                            // rows scroll up underneath it.
                            style={{
                              scrollMarginTop: "100px",
                              position: "relative",
                              // On the very first load there are no rows yet, so the
                              // wrapper would be too short to show the spinner.
                              minHeight: this.state.isLoading ? "260px" : undefined,
                            }}
                          >
                            {/* Sits over the table rather than replacing it, so the
                                page keeps its height and the scroll target above
                                does not move while a page is being fetched. */}
                            {this.state.isLoading && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  background: "rgba(255, 255, 255, 0.75)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "flex-start",
                                  paddingTop: "60px",
                                  zIndex: 10,
                                }}
                              >
                                <div class="text-center">
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    style={{ width: "3rem", height: "3rem" }}
                                  />
                                  <p
                                    class="mt-3"
                                    style={{
                                      fontSize: "15px",
                                      color: "#6c757d",
                                    }}
                                  >
                                    Loading orders...
                                  </p>
                                </div>
                              </div>
                            )}
                            <table class="table table-bordered table-sm table-striped load_sec">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Customer</th>
                                  <th>Pharmacy</th>
                                  <th>Order ID</th>
                                  <th>Order Date</th>
                                  {/* <th>Prescription</th> */}
                                  {/* <th>Items</th> */}
                                  <th>Invoice Number</th>
                                  <th>Medley Platform Fee</th>
                                  <th>Delivery charges</th>
                                  <th>To be Paid</th>
                                  <th>Invoice Value</th>
                                  <th>Status</th>
                                  {/* <th>Action</th> */}
                                  {/* <th>Settlement Status</th>
                                  <th>Reference No</th>
                                  <th>Update</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {Object.keys(this.state.ordersView).length >
                                0 ? (
                                  this.state.ordersView
                                ) : (
                                  <React.Fragment>
                                    <td>No orders found</td>
                                  </React.Fragment>
                                )}
                              </tbody>
                            </table>
                            {this.state.totalCount > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                  margin: "15px 0",
                                }}
                              >
                                <p style={{ margin: 0 }}>
                                  Showing{" "}
                                  {(this.state.pageNumber - 1) *
                                    this.state.pageSize +
                                    1}{" "}
                                  to{" "}
                                  {Math.min(
                                    this.state.pageNumber * this.state.pageSize,
                                    this.state.totalCount
                                  )}{" "}
                                  of {this.state.totalCount} orders
                                </p>
                                {this.state.totalPages > 1 && (
                                <Pagination>
                                  <Pagination.First
                                    onClick={() => this.handlePageChange(1)}
                                    disabled={this.state.pageNumber === 1}
                                  />
                                  <Pagination.Prev
                                    onClick={() =>
                                      this.handlePageChange(
                                        this.state.pageNumber - 1
                                      )
                                    }
                                    disabled={this.state.pageNumber === 1}
                                  />
                                  {[...Array(this.state.totalPages)].map(
                                    (_, index) => {
                                      const pageNum = index + 1;
                                      if (
                                        pageNum === 1 ||
                                        pageNum === this.state.totalPages ||
                                        (pageNum >= this.state.pageNumber - 2 &&
                                          pageNum <= this.state.pageNumber + 2)
                                      ) {
                                        return (
                                          <Pagination.Item
                                            key={pageNum}
                                            active={
                                              pageNum === this.state.pageNumber
                                            }
                                            onClick={() =>
                                              this.handlePageChange(pageNum)
                                            }
                                          >
                                            {pageNum}
                                          </Pagination.Item>
                                        );
                                      } else if (
                                        pageNum === this.state.pageNumber - 3 ||
                                        pageNum === this.state.pageNumber + 3
                                      ) {
                                        return (
                                          <Pagination.Ellipsis key={pageNum} />
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                  <Pagination.Next
                                    onClick={() =>
                                      this.handlePageChange(
                                        this.state.pageNumber + 1
                                      )
                                    }
                                    disabled={
                                      this.state.pageNumber ===
                                      this.state.totalPages
                                    }
                                  />
                                  <Pagination.Last
                                    onClick={() =>
                                      this.handlePageChange(
                                        this.state.totalPages
                                      )
                                    }
                                    disabled={
                                      this.state.pageNumber ===
                                      this.state.totalPages
                                    }
                                  />
                                </Pagination>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button onClick="topFunction()" id="myBtn" title="Go to top">
                  <img src="https://i.pinimg.com/originals/c4/f0/4b/c4f04b83f93836a05b4f188180708e0e.png" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* </section> */}

        <div id="main_dashboard" class={this.state.orderDetailsView}>
          <div class="container">
            <div class="row">
              <div class="col-md-12 no_padding">
                <section id="retailer_invoice">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="ret_inv_section">
                          <span
                            class="ret_inv_back"
                            onClick={this.showListView}
                          >
                            {" "}
                            <a href="#">
                              <img src="../images/retailer/back-arrow.jpg" />
                              Back to Order
                            </a>{" "}
                          </span>
                          <div class="ret_inv_head">
                            <h2> Order Details</h2>
                          </div>
                          <div class="ret_pharm_det">
                            <div class="row">
                              <div class="col-md-8">
                                <div class="pharm_add">
                                  <h2>New Pharmacy</h2>
                                  <h5>
                                    D NO. 131, Axis Bank, Madhapur, Hyderabad
                                  </h5>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="pharm_order">
                                  <p>
                                    Order No: <span>524163</span>
                                  </p>
                                  <p>
                                    Order Date: <span>14 Dec 2020</span>
                                  </p>
                                  <p>
                                    Invoice Date:{" "}
                                    <span>14 Dec 2020 02:30 PM</span>
                                  </p>
                                  <p>
                                    Invoice No: <span>5421525</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="ret_invoice_table" id="reg_form">
                            <div class="table-responsive dataTables_wrapper">
                              <table class="table table-bordered table-sm table-striped">
                                <thead>
                                  <tr>
                                    <th>Sl.No</th>
                                    <th>Product / Manufacturer</th>
                                    <th>Batch / Expiry</th>
                                    <th>MRP</th>
                                    <th>Qty</th>
                                    <th>Taxable Amnt</th>
                                    <th>Vat %</th>
                                    <th>Vat Amount</th>
                                    <th>Discount</th>
                                    <th>Total Amnt</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>
                                      Dolo 650 <h6>Micro Labs ltd</h6>
                                    </td>
                                    <td class="batch_inp">
                                      <input
                                        type="text"
                                        class="form-control"
                                        value="88789- 23/5"
                                      />
                                    </td>
                                    <td>₹ 400</td>
                                    <td>2</td>
                                    <td>₹ 400</td>
                                    <td>5</td>
                                    <td>₹ 55.32</td>
                                    <td>10</td>
                                    <td>₹ 75.30</td>
                                  </tr>

                                  <tr>
                                    <td>2</td>
                                    <td>
                                      Dolo 650 <h6>Micro Labs ltd</h6>
                                    </td>
                                    <td class="batch_inp">
                                      <input
                                        type="text"
                                        class="form-control"
                                        value="88789- 23/5"
                                      />
                                    </td>
                                    <td>₹ 400</td>
                                    <td>2</td>
                                    <td>₹ 400</td>
                                    <td>5</td>
                                    <td>₹ 55.32</td>
                                    <td>10</td>
                                    <td>₹ 75.30</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="ret_inv_footer">
                              <div class="row">
                                <div class="col-md-offset-7 col-md-5 amount__right">
                                  <div class="total_tax">
                                    <h5>
                                      Total Taxable Amount :{" "}
                                      <span>₹ 71.64</span>
                                    </h5>
                                    <h5>
                                      Total Taxes : <span>₹ 71.64</span>
                                    </h5>
                                  </div>
                                  <div class="total_amnt">
                                    <p>
                                      Sub Total : <span>₹ 71.64</span>
                                    </p>
                                    <p>
                                      Discount : <span> - ₹ 71.64</span>
                                    </p>
                                    <h3>
                                      Total Paid : <span>₹ 223.00</span>
                                    </h3>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ret_inv_pay">
                              <div class="row">
                                <div class="col-md-8">
                                  <div class="payment_mode">
                                    <p>
                                      Payment mode: <span>Card</span>
                                    </p>
                                    <p>
                                      Address : <span>Madhapur, Hyderabad</span>
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="ret_inv_btns">
                                    <p
                                      class="process_btn"
                                      data-toggle="modal"
                                      data-target="#reject_reason"
                                    >
                                      Cancel Order
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="reject_reason" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
                <h2>Reason For Cancellation</h2>
              </div>
              <div class="modal-body">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="reject_content">
                        <div class="rej_main">
                          {this.state.retailerRejectList}

                          <textarea
                            class="form-control"
                            rows="3"
                            placeholder="Type Reason"
                            id="otherReason"
                          ></textarea>
                        </div>
                      </div>
                      <div class="reject_bottom">
                        <div class="row">
                          <div class="col-md-4">
                            <button
                              type="button"
                              class="cancel_btn"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                          <div class="col-md-8">
                            <button
                              type="button"
                              class="save_btn"
                              onClick={this.rejectOrder}
                            >
                              Initiate Refund
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ToastContainer />
          </div>
        </div>
      </section>
    );
  }
}
